import { SAVE_ORGANISATIONS_INFO, SAVE_USER_INFO } from '../actions/actionTypes';

export const currentOrganisation = (state = '', action) => {
  switch (action.type) {
    case SAVE_USER_INFO:
      return action.payload.currentOrganisation;
    default:
      return state;
  }
};

export const organisations = (state, action) => {
  const initState = {
    byId: {},
    allIds: [],
  };
  const { type, payload } = action;
  switch (type) {
    case SAVE_ORGANISATIONS_INFO: {
      return {
        byId: { ...payload.organisations.entities.organisations },
        allIds: [...payload.organisations.result],
      };
    }
    default:
      if (!state) {
        return initState;
      }
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/organisations.js